/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DashboardStatsClearanceCompliance model module.
 * @module model/DashboardStatsClearanceCompliance
 * @version v0.3
 */
export default class DashboardStatsClearanceCompliance {
  /**
   * Constructs a new <code>DashboardStatsClearanceCompliance</code>.
   * @alias module:model/DashboardStatsClearanceCompliance
   * @class
   * @param achieved {Number}
   * @param total {Number}
   * @param percentage {Number}
   */
  constructor(achieved, total, percentage) {
    this.achieved = achieved;
    this.total = total;
    this.percentage = percentage;
  }

  /**
   * Constructs a <code>DashboardStatsClearanceCompliance</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardStatsClearanceCompliance} obj Optional instance to populate.
   * @return {module:model/DashboardStatsClearanceCompliance} The populated <code>DashboardStatsClearanceCompliance</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DashboardStatsClearanceCompliance();
      if (data.hasOwnProperty('achieved'))
        obj.achieved = ApiClient.convertToType(data['achieved'], 'Number');
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'Number');
      if (data.hasOwnProperty('percentage'))
        obj.percentage = ApiClient.convertToType(data['percentage'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} achieved
 */
DashboardStatsClearanceCompliance.prototype.achieved = undefined;

/**
 * @member {Number} total
 */
DashboardStatsClearanceCompliance.prototype.total = undefined;

/**
 * @member {Number} percentage
 */
DashboardStatsClearanceCompliance.prototype.percentage = undefined;
